import * as theme from "../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteIcon from "@material-ui/icons/Delete";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  loadBrokerages,
  getBrokeragesList,
  loadAboutUs,
  aboutUsFormDataSelecter,
  aboutUsAddedSelector,
  addAboutUs,
  deleteAboutUs,
} from "../store/aboutUs";
import Select from "react-dropdown-select";
import FormEditor from "./FormEditor";

import { useNavigate } from "react-router-dom";

const BrokerageSuperAdminAboutUs = (props) => {
  const dispatch = useDispatch();

  let navigate = useNavigate();
  const [selectedBrokerageCode, setSelectedBrokerageCode] = useState(null);
  const brokeragesList = useSelector(getBrokeragesList);
  const [selectedBrokerageName, setSelectedBrokerageName] = useState(
    "Search for a brokerage"
  );
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);

  useEffect(() => {
    if (
      !props.brokerageCode &&
      !selectedBrokerageCode &&
      brokeragesList &&
      brokeragesList[0]?.code
    ) {
      setSelectedBrokerageCode(brokeragesList[0].code);
      setSelectedBrokerageName(brokeragesList[0].name);
      dispatch(loadAboutUs(brokeragesList[0].code));
    } else if (props.brokerageCode && brokeragesList) {
      dispatch(loadAboutUs(props.brokerageCode));
      for (let br of brokeragesList) {
        if (br.code === props.brokerageCode) {
          setSelectedBrokerageName(br.name);
          setSelectedBrokerageCode(props.brokerageCode);
          break;
        }
      }
    }
  }, [brokeragesList]);

  const onChangeHandle = (value) => {
    if (value[0]?.code) {
      navigate(
        "/quoteyadmin/aboutus?c=" + encodeURIComponent(value[0].code)
      );
      dispatch(loadAboutUs(value[0].code));
      setSelectedBrokerageCode(value[0].code);
      setSelectedBrokerageName(value[0].name);
    }
  };

  return (
    <>
      {selectedBrokerageCode ? (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
            }}
          >
            <div
              style={{
                width: "80%",
                marginLeft: "10%",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <Select
                placeholder={selectedBrokerageName}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(value) => onChangeHandle(value)}
                values={[]}
                options={brokeragesList}
                style={{
                  width: "100%",
                  height: "6vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <AboutUsWrapper
            brokerageCode={selectedBrokerageCode}
            brokeragesList={brokeragesList}
          ></AboutUsWrapper>
        </>
      ) : (
        <div
          style={{
            display: "flex",
            position: "relative",
            left: "45%",
            marginTop: "20%",
            height: "25vh",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </>
  );
};

export const AboutUsWrapper = (props) => {
  const dispatch = useDispatch();
  let allAbout = useSelector(aboutUsFormDataSelecter);
  let justAdded = useSelector(aboutUsAddedSelector);
  const [toggleUpdateUserModel, setToggleUpdateUserModel] = useState(false);
  const [toggleNewUserModel, settoggleNewUserModel] = useState(false);
  const [toggleCancelUserModel, setToggleCancelUserModel] = useState(false);
  const [aboutUsIndex, setAboutUsIndex] = useState(0);

  useEffect(() => {
    if(justAdded)
      dispatch(loadAboutUs(props.brokerageCode))
  }, [justAdded]);

  const onNewUserModelChangeHandle = (value) => {
    settoggleNewUserModel(value);
  };
  const onUpdateUserModelChangeHandle = (value, index) => {
    setAboutUsIndex(index);
    setToggleUpdateUserModel(value);
  };
  const onCancelUserModelChangeHandle = (value, index) => {
    setAboutUsIndex(index);
    setToggleCancelUserModel(value);
  };
  return (
    <div className="m-4">
      <div className="d-flex">
        <div
          className="m-4"
          style={{
            width: "100%",
          }}
        >
          <div
            className="d-flex"
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: "1.2vw",
            }}
          >
            You can add, suspend and update about us in your brokerage
          </div>

          <div
            className="d-flex m-2"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              paddingTop: "25px",
              fontSize: "0.8vw",
            }}
          >
            <table className="table  table-sm">
              <thead>
                <tr>
                  <th scope="col">Title name</th>
                  <th scope="col">Body</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {allAbout.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item?.title}</td>
                      <td>{item?.body[0]?.data?.text}</td>
                      <td className="text-center">
                        <Button
                          style={{
                            color: "white",
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            backgroundColor: theme.COLORS.secondary_skyblue,
                            border: 0,
                            width: "5vw",
                          }}
                          onClick={() =>
                            onUpdateUserModelChangeHandle(true, index)
                          }
                        >
                          Update
                        </Button>
                        <DeleteIcon
                          color="error"
                          style={{
                            height: "3.5vh",
                            fontFamily: "GibsonSemiBd",
                            fontSize: 12,
                            border: 0,
                            width: "3vw",
                            margin: "0 .5rem",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            // dispatch(
                            //   deleteAboutUs({
                            //     code: props.brokerageCode,
                            //     id: item?._id,
                            //   })
                            // );
                            onCancelUserModelChangeHandle(true, index)
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div>
            <Button
              style={{
                color: "white",
                height: "4vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                border: 0,
                width: "10vw",
              }}
              onClick={() => {
                onNewUserModelChangeHandle(true);
              }}
            >
              Add new about us
            </Button>
          </div>
        </div>
      </div>
      <AddUserModal
        brokerageCode={props.brokerageCode}
        settoggleNewUserModel={settoggleNewUserModel}
        toggleNewUserModel={toggleNewUserModel}
        aboutUsIndex={aboutUsIndex}
        aboutUsList={allAbout}
      ></AddUserModal>
      <UpdateUserModal
        brokerageCode={props.brokerageCode}
        setToggleUpdateUserModel={setToggleUpdateUserModel}
        toggleUpdateUserModel={toggleUpdateUserModel}
        aboutUsList={allAbout}
        aboutUsIndex={aboutUsIndex}
      ></UpdateUserModal>
      <ConfirmDeleteModal
        brokerageCode={props.brokerageCode}
        setToggleCancelUserModel={setToggleCancelUserModel}
        toggleCancelUserModel={toggleCancelUserModel}
        aboutUsList={allAbout}
        aboutUsIndex={aboutUsIndex}
      ></ConfirmDeleteModal>
    </div>
  );
};

const AddUserModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleNewUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "65vh",
          width: "40vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <NewUser
        brokerageCode={props.brokerageCode}
        settoggleNewUserModel={props.settoggleNewUserModel}
        toggleNewUserModel={props.toggleNewUserModel}
        setAboutUsList={props.setAboutUsList}
        aboutUsList={props.aboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></NewUser>
    </Modal>
  );
};

const NewUser = (props) => {
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="row ml-1 p-3">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
            >
              Add a new About Us
            </span>
          </div>

          <div
            className="ml-auto"
            style={{ marginTop: "-15px", marginRight: "-10px" }}
          >
            <CancelIcon
              fontSize="small"
              style={{ cursor: "pointer" }}
              onClick={() => {
                props.settoggleNewUserModel(false);
              }}
            ></CancelIcon>
          </div>
        </div>
        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
          }}
        >
          <div className="col-10">
            <FormEditor
              buttonText="Add about us"
              aboutUsList={props.aboutUsList}
              setAboutUsList={props.setAboutUsList}
              aboutUsIndex={props.aboutUsIndex}
              brokerageCode={props.brokerageCode}
              settoggleNewUserModel={props.settoggleNewUserModel}
            />
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  );
};
const UpdateUserModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleUpdateUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "70vh",
          width: "50vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <UpdateUser
        brokerageCode={props.brokerageCode}
        setToggleUpdateUserModel={props.setToggleUpdateUserModel}
        toggleUpdateUserModel={props.toggleUpdateUserModel}
        aboutUsList={props.aboutUsList}
        setAboutUsList={props.setAboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></UpdateUser>
    </Modal>
  );
};

const ConfirmDeleteModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props.toggleCancelUserModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "18vh",
          width: "30vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "auto",
        },
      }}
    >
      <CancelUser
        brokerageCode={props.brokerageCode}
        setToggleCancelUserModel={props.setToggleCancelUserModel}
        toggleUpdateUserModel={props.toggleUpdateUserModel}
        aboutUsList={props.aboutUsList}
        setAboutUsList={props.setAboutUsList}
        aboutUsIndex={props.aboutUsIndex}
      ></CancelUser>
    </Modal>
  );
}

const UpdateUser = (props) => {
  return (
    <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
      <div className="row ml-1 p-3">
        <div>
          <span
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
          >
            Update About Us
          </span>
        </div>

        <div
          className="ml-auto"
          style={{ marginTop: "-15px", marginRight: "-10px" }}
        >
          <CancelIcon
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.setToggleUpdateUserModel(false);
            }}
          ></CancelIcon>
        </div>
      </div>

      <div
        className="row pt-3  justify-content-center"
        style={{
          fontFamily: "GibsonRegular",
        }}
      >
        <div className="col-8">
          <FormEditor
            buttonText="Update"
            aboutUsList={props.aboutUsList}
            setAboutUsList={props.setAboutUsList}
            brokerageCode={props.brokerageCode}
            aboutUsIndex={props.aboutUsIndex}
            setToggleUpdateUserModel={props.setToggleUpdateUserModel}
          />
        </div>
      </div>
    </div>
  );
};

const CancelUser = (props) => {
  const dispatch = useDispatch();
  return (
    <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
      <div className="row ml-1 p-3">
        <div>
          <span
            className="text-center"
            style={{ fontFamily: "GibsonSemiBd", fontSize: "17px" }}
          >
            Are you sure you want to delete?
          </span>
        </div>

        <div
          className="ml-auto"
          style={{ marginTop: "-15px", marginRight: "-10px" }}
        >
          <CancelIcon
            fontSize="small"
            style={{ cursor: "pointer" }}
            onClick={() => {
              props.setToggleCancelUserModel(false);
            }}
          ></CancelIcon>
        </div>
      </div>

      <div
        className="row pt-3  justify-content-center"
        style={{
          fontFamily: "GibsonRegular",
        }}
      >
        <div className="col-8" style={{display:'flex', justifyContent: 'space-evenly'}}>
          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.red_star,
              border: 0,
              width: "5vw",
            }}
            onClick={() => {
              dispatch(
                deleteAboutUs({
                  code: props.brokerageCode,
                  id: props.aboutUsList[props.aboutUsIndex]?._id,
                })
              );
              setTimeout(() => {
                props.setToggleCancelUserModel(false);
              }, 400);
            }}
          >
            Yes
          </Button>

          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.secondary_skyblue,
              border: 0,
              width: "5vw",
            }}
            onClick={() =>
              props.setToggleCancelUserModel(false)
            }
          >
            No
          </Button>
          
        </div>
      </div>
    </div>
  );
};

export default BrokerageSuperAdminAboutUs;
